var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path, _rect9, _rect10, _g, _rect11, _rect12, _g2, _rect13, _rect14, _rect15, _path2, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect22, _circle, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriversLicenseFrontBad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3752_75419)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 13.374,
    width: 1.06653,
    height: 7.46567,
    fill: "#C8253C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 14.4404,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(-90 5.90625 14.4404)",
    fill: "#C8253C"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 13.374,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(90 117.359 13.374)",
    fill: "#C8253C"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 116.289,
    y: 13.374,
    width: 1.06653,
    height: 7.46567,
    fill: "#C8253C"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.90625,
    y: 110.962,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(-90 5.90625 110.962)",
    fill: "#C8253C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 110.962,
    width: 1.06653,
    height: 7.46567,
    transform: "rotate(-180 117.359 110.962)",
    fill: "#C8253C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 6.97656,
    y: 110.962,
    width: 1.06653,
    height: 7.46567,
    transform: "rotate(-180 6.97656 110.962)",
    fill: "#C8253C"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 117.359,
    y: 109.895,
    width: 1.06652,
    height: 7.46569,
    transform: "rotate(90 117.359 109.895)",
    fill: "#C8253C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.664 87.1191C113.664 88.7013 111.998 89.9844 109.944 89.9844L-9.56934 89.9844C-11.6231 89.9842 -13.288 88.7011 -13.2881 87.1191L-13.2881 27.6377C-13.2881 25.0108 -11.1591 22.8809 -8.53223 22.8809L109.944 22.8809C111.998 22.8809 113.664 24.1639 113.664 25.7461L113.664 87.1191Z",
    fill: "url(#paint0_linear_3752_75419)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -6.03125,
    y: 45.0986,
    width: 28.9366,
    height: 28.9365,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3752_75419",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -7,
    y: 45,
    width: 30,
    height: 30
  }, _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -6.03125,
    y: 45.0986,
    width: 28.9366,
    height: 28.9365,
    fill: "#F9F9F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3752_75419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.01055 52.8994L1.80452 54.5564C1.38968 57.8929 3.99457 60.8386 7.35677 60.8386C7.99744 60.8386 8.63373 60.949 9.23686 61.1651C12.8674 62.4657 16.69 59.7747 16.69 55.9182V53.9622C16.69 53.0794 16.4037 52.2204 15.874 51.5141L14.7916 50.0707C13.9453 48.9421 12.8311 48.0423 11.5497 47.4525C9.34339 46.437 6.72636 47.16 5.35426 49.1641L5.00132 49.6796C3.41508 49.9969 2.21015 51.2941 2.01055 52.8994Z",
    fill: "#494C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.39062 81.8284V74.5771C-3.39062 70.5537 -0.203413 67.2533 3.81762 67.113L5.79565 67.0439H11.4008L13.2166 67.1084C17.2898 67.253 20.567 70.5052 20.7428 74.5771V81.8284L8.54349 84.1938L-3.39062 81.8284Z",
    fill: "#BBC3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84955 66.5713V64.1014C5.84955 63.7569 6.12888 63.4775 6.47345 63.4775H10.5284C10.873 63.4775 11.1523 63.7569 11.1523 64.1014V66.5713C11.1523 66.6901 11.1862 66.8065 11.2499 66.9067L12.0367 68.1432C12.1721 68.356 12.244 68.6031 12.244 68.8554C12.244 69.2197 12.0942 69.5681 11.8296 69.8186L11.0788 70.5297C9.71185 71.8242 7.58637 71.8722 6.16237 70.6408L5.2001 69.8086C4.91923 69.5657 4.75781 69.2127 4.75781 68.8414C4.75781 68.5983 4.82715 68.3601 4.95768 68.155L5.7519 66.9067C5.81568 66.8065 5.84955 66.6901 5.84955 66.5713Z",
    fill: "#A2ABB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2821 58.6964L14.8342 59.6668C14.677 60.0075 14.3859 60.2681 14.03 60.3868C13.7885 60.4673 13.59 60.6425 13.4802 60.8721L12.6534 62.6012C12.194 63.5618 11.3747 64.3027 10.3729 64.6634L10.1063 64.7594C8.76906 65.2409 7.30574 65.2409 5.96848 64.7594C4.82696 64.3484 3.97072 63.388 3.69287 62.207L3.22344 60.2116C3.00368 59.2775 2.96861 58.3094 3.1202 57.3619L3.21708 56.7562C3.41377 55.5268 3.82814 54.3422 4.44073 53.2583L5.29727 51.7426C5.42334 51.5195 5.72282 51.4691 5.91494 51.6387L8.09362 53.5613C8.15937 53.6194 8.23662 53.6629 8.32032 53.689L10.6888 54.4293L11.5763 54.803C12.8479 55.3385 13.7065 56.5481 13.7925 57.9251C13.7971 57.9976 13.8933 58.0194 13.9286 57.9559L14.2361 57.4023C14.3967 57.1133 14.8062 57.0967 14.9896 57.3718L15.2039 57.6933C15.4025 57.9913 15.4321 58.3711 15.2821 58.6964Z",
    fill: "url(#paint1_linear_3752_75419)"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 91.8984,
    y: 57.3389,
    width: 14.4681,
    height: 14.468,
    fill: "#F9F9F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3752_75419",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 57,
    width: 16,
    height: 15
  }, _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 91.8984,
    y: 57.3389,
    width: 14.4681,
    height: 14.468,
    fill: "#F9F9F9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3752_75419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.9232 61.2392L95.8202 62.0677C95.6128 63.7359 96.9152 65.2087 98.5963 65.2087C98.9166 65.2087 99.2348 65.2639 99.5363 65.372C101.352 66.0223 103.263 64.6768 103.263 62.7486V61.7706C103.263 61.3292 103.12 60.8997 102.855 60.5465L102.314 59.8249C101.891 59.2606 101.333 58.8107 100.693 58.5158C99.5896 58.008 98.2811 58.3695 97.5951 59.3716L97.4186 59.6293C96.6255 59.7879 96.023 60.4365 95.9232 61.2392Z",
    fill: "#494C50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2188 75.7036V72.0781C93.2188 70.0663 94.8123 68.4162 96.8228 68.346L97.8118 68.3115H100.614L101.522 68.3438C103.559 68.416 105.197 70.0421 105.285 72.0781V75.7036L99.1857 76.8863L93.2188 75.7036Z",
    fill: "#BBC3CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8349 68.0752V66.8403C97.8349 66.668 97.9746 66.5283 98.1469 66.5283H100.174C100.347 66.5283 100.486 66.668 100.486 66.8403V68.0752C100.486 68.1346 100.503 68.1928 100.535 68.2429L100.928 68.8611C100.996 68.9675 101.032 69.0911 101.032 69.2172C101.032 69.3994 100.957 69.5735 100.825 69.6988L100.449 70.0543C99.766 70.7016 98.7033 70.7256 97.9913 70.1099L97.5102 69.6938C97.3698 69.5724 97.2891 69.3959 97.2891 69.2102C97.2891 69.0886 97.3237 68.9696 97.389 68.867L97.7861 68.2429C97.818 68.1928 97.8349 68.1346 97.8349 68.0752Z",
    fill: "#A2ABB6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.555 64.1377L102.331 64.6229C102.252 64.7932 102.107 64.9235 101.929 64.9829C101.808 65.0231 101.709 65.1107 101.654 65.2255L101.241 66.0901C101.011 66.5703 100.601 66.9408 100.1 67.1211L99.9672 67.1691C99.2985 67.4099 98.5669 67.4099 97.8983 67.1691C97.3275 66.9636 96.8994 66.4834 96.7605 65.8929L96.5258 64.8953C96.4159 64.4282 96.3984 63.9442 96.4742 63.4704L96.5226 63.1676C96.6209 62.5529 96.8281 61.9606 97.1344 61.4187L97.5627 60.6609C97.6257 60.5493 97.7754 60.5241 97.8715 60.6089L98.9608 61.5702C98.9937 61.5992 99.0323 61.621 99.0742 61.6341L100.258 62.0042L100.702 62.191C101.338 62.4588 101.767 63.0635 101.81 63.7521C101.813 63.7883 101.861 63.7992 101.878 63.7674L102.032 63.4906C102.112 63.3461 102.317 63.3378 102.409 63.4754L102.516 63.6362C102.615 63.7852 102.63 63.9751 102.555 64.1377Z",
    fill: "url(#paint2_linear_3752_75419)"
  })))), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 40.768,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -1.27572e-08 -5.19345e-06 1 65.6016 47.3643)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 40.806,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -1.95549e-08 -3.38809e-06 1 65.6016 51.5332)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 19.0552,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -1.27572e-08 -5.19345e-06 1 87.3672 75.4756)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5176 81.1713C10.5262 79.585 11.3545 76.1509 11.1588 73.7512C10.9927 71.7161 9.52409 71.5476 7.76656 72.1634C5.03602 73.1202 2.04637 74.7589 1.48286 77.7856C1.06668 80.021 0.765812 83.7524 3.64836 84.4704C6.11439 85.0847 7.98619 81.7036 7.81663 79.602C7.72943 78.5212 6.2895 78.9859 6.12679 79.8182C5.67914 82.1081 8.27404 83.2245 10.2325 82.9259C11.2232 82.7748 11.9808 82.1619 12.5607 81.3875C12.6788 81.2298 12.9181 80.5071 13.2116 80.7141C14.0249 81.2875 14.8841 81.6726 15.7276 82.1721",
    stroke: "#83888E",
    strokeOpacity: 0.8,
    strokeWidth: 0.906802,
    strokeLinecap: "round"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3641,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 27.5156 45.0986)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 29.9381,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 27.5156 55.5342)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 45.5312,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 27.5156 72.0566)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 9.32602,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 27.5156 49.2676)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 16.8686,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 27.5156 59.7031)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 46.0381,
    height: 1.95255,
    rx: 0.976273,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 27.5156 76.2266)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0234 35.5767V30.3008H59.5785V31.2205H57.1389V32.4776H59.3956V33.3973H57.1389V34.657H59.5888V35.5767H56.0234Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5556 31.818C53.5349 31.6102 53.4465 31.4487 53.2902 31.3337C53.1339 31.2186 52.9218 31.1611 52.6539 31.1611C52.4719 31.1611 52.3181 31.1868 52.1928 31.2384C52.0674 31.2882 51.9712 31.3577 51.9043 31.447C51.839 31.5363 51.8064 31.6377 51.8064 31.751C51.8029 31.8455 51.8227 31.9279 51.8656 31.9983C51.9103 32.0687 51.9712 32.1297 52.0485 32.1812C52.1258 32.231 52.2151 32.2748 52.3164 32.3126C52.4178 32.3487 52.526 32.3796 52.641 32.4054L53.115 32.5187C53.3452 32.5702 53.5564 32.6389 53.7488 32.7248C53.9411 32.8107 54.1077 32.9163 54.2485 33.0417C54.3894 33.167 54.4984 33.3147 54.5757 33.4848C54.6547 33.6548 54.6951 33.8497 54.6968 34.0695C54.6951 34.3924 54.6126 34.6724 54.4495 34.9094C54.288 35.1447 54.0545 35.3276 53.7488 35.4581C53.4448 35.5869 53.0781 35.6513 52.6488 35.6513C52.2228 35.6513 51.8519 35.586 51.5359 35.4555C51.2216 35.325 50.976 35.1318 50.7991 34.8759C50.6239 34.6183 50.532 34.2997 50.5234 33.9201H51.6028C51.6149 34.097 51.6655 34.2447 51.7548 34.3632C51.8459 34.48 51.9669 34.5685 52.1181 34.6286C52.2709 34.687 52.4435 34.7162 52.6359 34.7162C52.8248 34.7162 52.9888 34.6887 53.1279 34.6337C53.2687 34.5788 53.3778 34.5023 53.4551 34.4044C53.5324 34.3065 53.571 34.1941 53.571 34.067C53.571 33.9485 53.5358 33.8489 53.4654 33.7681C53.3967 33.6874 53.2954 33.6187 53.1614 33.562C53.0292 33.5054 52.8669 33.4538 52.6745 33.4075L52.1 33.2632C51.6552 33.155 51.304 32.9858 51.0464 32.7557C50.7888 32.5256 50.6608 32.2156 50.6626 31.8257C50.6608 31.5063 50.7458 31.2272 50.9176 30.9885C51.091 30.7498 51.3289 30.5634 51.6312 30.4295C51.9334 30.2955 52.2769 30.2285 52.6616 30.2285C53.0532 30.2285 53.395 30.2955 53.6869 30.4295C53.9806 30.5634 54.209 30.7498 54.3722 30.9885C54.5353 31.2272 54.6195 31.5037 54.6247 31.818H53.5556Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1942 30.3008V35.5767H48.2307L45.9354 32.2561H45.8967V35.5767H44.7812V30.3008H45.7602L48.0375 33.6189H48.0839V30.3008H49.1942Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7578 35.5767V30.3008H43.3129V31.2205H40.8733V32.4776H43.13V33.3973H40.8733V34.657H43.3232V35.5767H39.7578Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3728 32.1477H37.2445C37.2239 32.0018 37.1818 31.8721 37.1182 31.7587C37.0547 31.6437 36.9731 31.5458 36.8735 31.4651C36.7739 31.3843 36.6588 31.3225 36.5283 31.2796C36.3995 31.2366 36.2595 31.2152 36.1084 31.2152C35.8353 31.2152 35.5975 31.283 35.3948 31.4187C35.1922 31.5527 35.035 31.7484 34.9234 32.0061C34.8117 32.2619 34.7559 32.5728 34.7559 32.9386C34.7559 33.3147 34.8117 33.6307 34.9234 33.8866C35.0367 34.1425 35.1947 34.3357 35.3974 34.4663C35.6 34.5968 35.8345 34.6621 36.1007 34.6621C36.2501 34.6621 36.3883 34.6423 36.5154 34.6028C36.6442 34.5633 36.7584 34.5058 36.8581 34.4302C36.9577 34.3529 37.0401 34.2593 37.1054 34.1494C37.1723 34.0395 37.2187 33.9141 37.2445 33.7733L38.3728 33.7784C38.3436 34.0206 38.2706 34.2542 38.1539 34.4791C38.0388 34.7024 37.8834 34.9025 37.6876 35.0794C37.4935 35.2546 37.2617 35.3937 36.992 35.4967C36.7241 35.5981 36.421 35.6487 36.0826 35.6487C35.6121 35.6487 35.1913 35.5422 34.8203 35.3293C34.4511 35.1163 34.1591 34.808 33.9444 34.4044C33.7315 34.0008 33.625 33.5122 33.625 32.9386C33.625 32.3633 33.7332 31.8738 33.9496 31.4702C34.166 31.0666 34.4597 30.7592 34.8306 30.548C35.2016 30.335 35.6189 30.2285 36.0826 30.2285C36.3883 30.2285 36.6717 30.2715 36.9328 30.3573C37.1955 30.4432 37.4282 30.5686 37.6309 30.7334C37.8336 30.8966 37.9984 31.0967 38.1255 31.3337C38.2543 31.5707 38.3368 31.842 38.3728 32.1477Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2248 30.3008V35.5767H31.1094V30.3008H32.2248Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4141 35.5767V30.3008H27.5295V34.657H29.7914V35.5767H26.4141Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8125 35.5767V30.3008H20.894C21.2925 30.3008 21.6325 30.3721 21.9142 30.5146C22.1975 30.6554 22.4131 30.8555 22.5608 31.1148C22.7102 31.3725 22.7849 31.6756 22.7849 32.0242C22.7849 32.3746 22.7093 32.676 22.5582 32.9284C22.4071 33.1792 22.1881 33.3715 21.9013 33.5055C21.6162 33.6395 21.271 33.7064 20.8657 33.7064H19.472V32.8099H20.6854C20.8983 32.8099 21.0752 32.7807 21.216 32.7224C21.3569 32.664 21.4616 32.5764 21.5303 32.4596C21.6007 32.3428 21.636 32.1977 21.636 32.0242C21.636 31.849 21.6007 31.7013 21.5303 31.5811C21.4616 31.4609 21.356 31.3699 21.2135 31.3081C21.0726 31.2445 20.8949 31.2127 20.6802 31.2127H19.928V35.5767H18.8125ZM21.6617 33.1758L22.973 35.5767H21.7416L20.4587 33.1758H21.6617Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7891 35.5767V30.3008H17.3441V31.2205H14.9045V32.4776H17.1612V33.3973H14.9045V34.657H17.3544V35.5767H13.7891Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73131 30.3008L10.0065 34.3093H10.0554L11.3332 30.3008H12.5698L10.751 35.5767H9.31352L7.49219 30.3008H8.73131Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.27953 30.3008V35.5767H5.16406V30.3008H6.27953Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-0.171875 35.5767V30.3008H1.90965C2.30809 30.3008 2.64814 30.3721 2.9298 30.5146C3.21317 30.6554 3.42871 30.8555 3.57641 31.1148C3.72583 31.3725 3.80053 31.6756 3.80053 32.0242C3.80053 32.3746 3.72497 32.676 3.57383 32.9284C3.4227 33.1792 3.20373 33.3715 2.91692 33.5055C2.63182 33.6395 2.28662 33.7064 1.88131 33.7064H0.487617V32.8099H1.70098C1.91394 32.8099 2.09083 32.7807 2.23166 32.7224C2.37249 32.664 2.47726 32.5764 2.54595 32.4596C2.61637 32.3428 2.65158 32.1977 2.65158 32.0242C2.65158 31.849 2.61637 31.7013 2.54595 31.5811C2.47726 31.4609 2.37164 31.3699 2.22909 31.3081C2.08826 31.2445 1.91051 31.2127 1.69583 31.2127H0.943594V35.5767H-0.171875ZM2.67734 33.1758L3.98859 35.5767H2.7572L1.47428 33.1758H2.67734Z",
    fill: "black",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 70.8601,
    y: 88.5711,
    width: 35.4282,
    height: 35.4282
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.48px)",
      clipPath: "url(#bgblur_1_3752_75419_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 2.95238,
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619,
    fill: "#DF2B44",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5751,
    cy: 106.285,
    r: 11.8095,
    fill: "#DF2B44"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2998 101.014C92.8488 100.465 93.739 100.465 94.2881 101.014C94.837 101.563 94.8371 102.453 94.2881 103.002L90.7832 106.506L94.2881 110.011C94.8371 110.56 94.8371 111.45 94.2881 111.999C93.739 112.548 92.8488 112.548 92.2998 111.999L88.7949 108.494L85.291 111.999C84.742 112.548 83.8518 112.548 83.3027 111.999C82.7537 111.45 82.7537 110.56 83.3027 110.011L86.8066 106.506L83.3027 103.002C82.7537 102.453 82.7537 101.563 83.3027 101.014C83.8518 100.465 84.742 100.465 85.291 101.014L88.7949 104.518L92.2998 101.014ZM93.0615 101.226H93.0625H93.0615Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_3752_75419_clip_path",
    transform: "translate(-70.8601 -88.5711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3752_75419",
    x1: -10.6343,
    y1: 57.7516,
    x2: 152.827,
    y2: 44.2513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607628,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3752_75419",
    x1: 5.55673,
    y1: 53.5069,
    x2: 11.6127,
    y2: 63.4806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB4BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3752_75419",
    x1: 97.6924,
    y1: 61.543,
    x2: 100.72,
    y2: 66.5297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ABB4BE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3752_75419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversLicenseFrontBad);
export default __webpack_public_path__ + "static/media/DriversLicenseFrontBad.2eafc998d177145c51b4dfc45a94d731.svg";
export { ForwardRef as ReactComponent };